export default {
    path: 'tag',
    component: () => import('../Tag.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách thẻ',
            component: () => import('../table/Table.vue'),
        },
    ]
};